export enum COI_CASE_STATUS {
  NEW = 'NEW',
  UNDER_REVIEW = 'UNDER REVIEW',
  PENDING_MITIGATION = 'PENDING MITIGATION',
  OVERDUE_MITIGATION = 'OVERDUE MITIGATION',
  CLOSED = 'CLOSED',
  AUTO_CLOSED = 'AUTO CLOSED',
}

export const ACTIONS_STATUSES = [
  COI_CASE_STATUS.NEW,
  COI_CASE_STATUS.UNDER_REVIEW,
];
export const WAITING_STATUSES = [
  COI_CASE_STATUS.PENDING_MITIGATION,
  COI_CASE_STATUS.OVERDUE_MITIGATION,
];
export const OPEN_STATUSES = [...ACTIONS_STATUSES, ...WAITING_STATUSES];
export const ALL_STATUSES = [...OPEN_STATUSES, COI_CASE_STATUS.CLOSED];

export type DisclosureDataset = 'open' | 'closed' | 'auto-closed' | null;

export type MetricCardId = 'assigned' | 'actions' | 'waiting';

export type DisclosureFilterColumn =
  | 'category'
  | 'status'
  | 'reviewer'
  | 'submittedDate'
  | 'formTitle'
  | 'customField';

export interface FilterOption {
  label: string;
  value: string;
}

export const CUSTOM_FIELD_TYPE = {
  TEXT: 'TEXT',
  SINGLE_SELECT: 'SINGLE_SELECT',
} as const;

export interface CustomFieldFilterOption {
  id: string;
  label: string;
  fieldType: string;
  options: FilterOption[];
}

export interface FilterOptionsByColumn {
  category: FilterOption[];
  status: FilterOption[];
  reviewer?: FilterOption[];
  formTitle: FilterOption[];
  customField?: CustomFieldFilterOption[];
}

export interface CustomFieldFilterSelection {
  fieldId: string;
  value: string;
}

export interface DisclosureFilterValue {
  status: string[];
  reviewer: string[];
  category: string[];
  formTitle: string[];
  submittedDate?: { from: string; to: string };
  customField?: CustomFieldFilterSelection;
}

export interface RowModel {
  id: string;
  status: string;
  disclosureId: string;
  formTitle: string;
  category: string;
  employee: string;
  country: string;
  submittedDate: string;
  reviewer: string;
  reviewerGroup: string[];
  flags: number;
}

export interface DisclosureMetrics {
  assigned: number;
  actions: number;
  waiting: number;
  isLoading: boolean;
}
